import { render, staticRenderFns } from "./folder-icon-open-close.vue?vue&type=template&id=20ce3ff4&"
import script from "./folder-icon-open-close.vue?vue&type=script&lang=js&"
export * from "./folder-icon-open-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports